import axios from "axios";
// import { ElMessage } from "element-plus";
// import { getCookies, removeToken } from "@/utils/storage";

import router from "@/router";
// 业务请求
const request = axios.create({
  // baseURL: "https://www.chnsoft.com.cn",
  baseURL: "", 
  timeout: 600000,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*"
  },
});

// request interceptor
request.interceptors.request.use(
  (config) => {
    if (config.config) {
      config.headers["Content-Type"] = config.config.headers["Content-Type"];
    }
    // const token = getCookies("Fanqie-Token");
    // if (token) {
    //   config.headers["X-Access-Token"] = token;                            
    // }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

request.interceptors.response.use(
  (response) => {
    if (response.config.responseType === "blob") {
      if (response.status === 200) {
        return response;
      } else {
        ElMessage({
          message: data.message,
          type: "error",
          duration: 5 * 1000,
        });
        return false;
      }
    } else {
      const { data } = response;
      //增删改
      
      if (data.code === 200) {
        this.$message({
          message:  data.message,
          type: 'success'
        });
        return data;
      //列表
      } else if (data.code === 300) {
        return data;
      } else if (data.code === 0) {
        this.$message({
          message:  data.message,
          type: 'success'
        });
        return data;
      } else if (data.code === 500) {
        ElMessage({
          message: data.message,
          type: "error",
          duration: 5 * 1000,
        });
        // return false;
      } else if (data.code === 1000) {
        this.$message({
          message:  data.message,
          type: 'success'
        });
        return data;
      } else {
        ElMessage({
          message: data.message,
          type: "error",
          duration: 5 * 1000,
        });
        return Promise.reject(data);
      }
    }
  },
  (error) => {
    if (
      error.hasOwnProperty("response") &&
      error.response.hasOwnProperty("status") &&
      error.response.status === 401
    ) {
      // removeToken();

      // let toPath = {
      //   path: "/login",
      //   query: { redirectUrl: router.currentRoute.path },
      // };
      // router.replace(toPath);
    } else {
      ElMessage({
        message: error.message,
        type: "error",
        duration: 5 * 1000,
      });
    }// for debug
    return Promise.reject(error);
  }
);

/**
 * 用于请求 gitee 的数据
 */
const requestA = axios.create({
  // baseURL: import.meta.env.VITE_APP_GITEE_BASE_API, // url = base url + request url
  baseURL: "http://192.168.30.83:8080",
  // baseURL: "http://192.168.30.233:8080",
  // baseURL:'http://192.168.30.155:8080',
  // baseURL:'http://192.168.30.157:8080',
  timeout: 60 * 1000,
});

const token =
  "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE3MDM3MDcyODQsInVzZXJuYW1lIjp7Im9yZ0NvZGUiOiIxLDIsMyIsImlkIjoiMSIsInVzZXJOYW1lIjoiYWRtaW4iLCJ0eXBlIjoiQ0xJRU5UIiwidXNlclJvbGUiOjAsImluZHVzdHJ5Q29kZSI6IiJ9fQ.9SSmeu67zAIWbA1dQMAK6xscMa84W127DobsSQW8EE8";

requestA.interceptors.request.use(
  (config) => {
    config.headers = {
      "X-Access-Token": token,
    };
    return config;
  },
  (error) => {
    // console.log(error);
    return Promise.reject(error);
  }
);

requestA.interceptors.response.use(
  (response) => {
    const { data, status, statusText } = response;
    if (status === 200) {
      return data;
    } else {
      ElMessage({
        message: statusText || "Error",
        type: "error",
        duration: 5 * 1000,
      });
      return false;
    }
  },
  (error) => {
    // console.log("err" + error);
    ElMessage({
      message: error.message,
      type: "error",
      duration: 5 * 1000,
    });
    return Promise.reject(error);
  }
);

export { request, requestA };
